export const TRANSPARENT_GREEN = 'rgba(110, 215, 171, 0.2)';
export const GREEN = 'var(--cl-green-300)';
export const GRAY = 'var(--cl-gray-500)';
export const DARK_GRAY = 'var(--cl-gray-1100)';

/** If there are less than or equal to this value, we limit the Slider markers */
export const SLIDER_MARKER_THRESHOLD = 10;
